import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { ImageService } from 'src/app/services/http/image/image.service';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';
import { DatafieldsEnum } from '../datafield.enum';
import { IDatafieldComponent } from '../datafield.interface';

@Component({
  selector: 'app-datafield-image',
  templateUrl: './datafield-image.component.html',
  styleUrls: ['./datafield-image.component.scss']
})
export class DatafieldImageComponent implements OnInit, OnDestroy, IDatafieldComponent {

  enableZoom: boolean = true;
  imageSource: any;
  isZoomOptionsDisabled: boolean = true
  label: string
  session: string
  lensSize: number = 150
  minimumZoom: number = 0.1
  maximumZoom: number = 3
  value: any
  datafield: Datafield
  subscriptionManager: Subscription = new Subscription()

  constructor(
    private datasheetService: DatasheetService,
    private imageService: ImageService,
    private snackbarService: SnackbarService,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    if (this.value) {
      this.imageSource = this.value
    }
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        let imageValue: string = this.imageSource ? this.imageSource : null
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.IMAGE, this.label, imageValue)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }

  preview(fileList: FileList) {
    this.imageService.loadImage(fileList)
      .pipe(take(1)).subscribe(loadedImage => {
        this.imageSource = loadedImage
      }, error => {
        this.snackbarService.showError(error)
      })
  }
}
